<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";
export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["TabloId", "DonemId", "Sorgulama","BirimId"],
  components: {
        Loader,
    },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Birimid: "",
      TableData: [],
      TableDataDetails: [],
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId(){
      this.Get();
    },
    BirimId(){
      this.Get();
    }
  },

  methods: {
    Get() {

      this.bugun = new Date();
      this.TableData = [];
      this.TableDataDetails = [];
      let Filter = "&DonemId=" + this.DonemId + "&Tabloid=" + this.TabloId + "&isPerformansHedefi=true&isStrPlanDegerlendirme=true";
      if(this.BirimId!=null && this.BirimId!=""){
        Filter=Filter+"&Birimid="+this.BirimId;
      }
      this.ActionsFilterGet({ Service: "StrRaporlama/GetStratejikPlanDegerlendirmeFormu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;

      });

    },
    ExcelExport(table, name){  
                if (!table.nodeType) table = this.$refs.StratejikPlanDegerlendirmeFormu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
    }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
      <Loader>
  <div>
   
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Stratejik Plan Değerlendirme Tablosu',
                  'Stratejik Plan Değerlendirme Tablosu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


   

  
    <div ref="StratejikPlanDegerlendirmeFormu" class="table-responsive">

      <div>

      <table>
      
        <tbody>

          <tr><td>

           <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
            <tbody> 
              <tr>
              <td style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" scope="col" colspan="6">Stratejik Plan Değerlendirme Tablosu</td>
              </tr>
              <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight: bold;" scope="col" colspan="1">{{ $t("StratejikPlanDegerlendirmeFormu.Table.Amac") }}</td>
            <td colspan="5">{{ TableData.Amac }}</td>
          </tr>
                <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight:bold;" scope="col" colspan="1">Amacın ilgili olduğu program/alt program adı</td>
            <td colspan="5">{{ TableData.Programad }}</td>
          </tr>
                <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight:bold;" scope="col" colspan="1">Amacın ilgili olduğu program/alt program hedefi</td>
            <td colspan="5">{{ TableData.Programhedef }}</td>
          </tr>
          <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight:bold;" scope="col" colspan="1">{{  TableData.TabloAdi }}</td>
            <td colspan="5">{{ TableData.Hedef }}</td>
          </tr>
          <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight:bold;" scope="col" colspan="1">{{  TableData.TabloAdi }} Performansı (%)</td>
            <td colspan="5">{{ TableData.HedefPerformansSonucu}}</td>
          </tr>
          <tr>
            <td style="background-color: rgb(7, 156, 165); font-weight:bold;" scope="col" colspan="1">{{ $t("StratejikPlanDegerlendirmeFormu.Table.SorumluBirim") }}</td>
            <td colspan="5">{{ TableData.SorumluBirimAdi }}</td>
          </tr>

 
          </tbody>
          </table>

          </td></tr>
          <tr>
            <td>

              <div class="table-responsive">
   
           <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
                 <tbody>
                   <tr>
                  <th style="background-color:rgb(7, 156, 165);text-align:center;">Performans Göstergesi</th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Hedef Etkisi (%) </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Plan Dönemi Başlangıç Değeri </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> İzleme Dönemindeki Yıl Sonu Hedeflenen Değer </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> {{TableData.DonemAdiGercek}} </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Performans(%) </th>

                   </tr>
                    <tr v-for="(SubData, index) in TableData.TabloDetay" :key="index">
                      <td :key="index" >{{ SubData.PerformanGostergesi }}</td>
                      <td style="text-align:center;">{{ SubData.HedefEtkisi }}</td>                   
                      <td style="text-align:center;">{{ SubData.BaslangicDegeri }}</td>
                      <td style="text-align:center;">{{ SubData.HedeflenenDeger | formatNoktaToVirgulMax3 }}</td>
                      <td style="text-align:center;">{{ SubData.GerceklesenDeger | formatNoktaToVirgulMax3 }}</td>
                      <td style="text-align:center;">{{ SubData.Performans  }}</td>
                   </tr>
                   <tr >
                  <th colspan="6" style="background-color:rgb(7, 156, 165);text-align:center;">Hedefe İlişkin Değerlendirmeler</th>
                   </tr>
                   <tr >
                   <td colspan="6" style="background-color:white; justify-content: space-between;" v-html="TableData.Degerlendirme"></td>
                   </tr>
                          <tr >
                   <th colspan="6" style="background-color:rgb(7, 156, 165);text-align:center;">Hedefe İlişkin Sapmanın Nedeni ve Alınacak Önlemler</th>
                   </tr>

                   <tr >
                   <td colspan="6" style="background-color:white; justify-content: space-between;" v-html="TableData.DegerlendirmeOnlem"></td>
                   </tr>
                 </tbody> 

               </table> 

              </div>

            </td>
          </tr>
        </tbody>
      </table>
     </div>

      <br />
    </div>
  </div>
</Loader>
</template>
